import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Checkbox, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import { useCallback } from "react";
import Dropzone from "../common/Dropzone";
import "./test.css";

import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ConfigData from "../config/config.json";
import { GlobalMessageContext } from "../app/App";
import { UserContext } from "../app/App";

const webserver = ConfigData.WEBSERVER;

export default function UploadDialog(props) {
  const { setGlobalMessage } = React.useContext(GlobalMessageContext);
  const { user } = React.useContext(UserContext);

  const theme = useTheme();
  const [checked, setChecked] = React.useState(false);
  const [file, setFile] = React.useState(null);
  const [multipartFile, setMultipartFile] = React.useState(null);
  const [alignment, setAlignment] = React.useState(null);

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  const handleClose = () => {
    props.setOpen();
    props.function();

    const formData = new FormData();
    formData.append("file", multipartFile);

    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/examResult/upload?result=" +
        alignment +
        "&apoID=" +
        props.apoID +
        "&processID=" +
        props.selectedProcess +
        "&examiner=" +
        user.name,
      { method: "POST", credentials: "include", body: formData }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Vorgang fehlgeschlagen");
        }
        return response;
      })
      .then(() => {
        //   setRowss(prev => {
        //     let rowsCopy = JSON.parse(JSON.stringify(prev));
        //     rowsCopy[index].active = activity;
        //     return rowsCopy;
        //   });
        setGlobalMessage({
          globalMessage: "Upload erfolgreich",
          severity: "success",
        });
      })
      .catch((error) => {
        setGlobalMessage({ globalMessage: error.message, severity: "error" });
      });
  };

  const onDrop = useCallback((acceptedFiles) => {
    // Loop through accepted files
    acceptedFiles.map((file) => {
      setMultipartFile(file);
      // Initialize FileReader browser API
      const reader = new FileReader();
      // onload callback gets called after the reader reads the file data
      reader.onload = function (e) {
        // add the image into the state. Since FileReader reading process is asynchronous, its better to get the latest snapshot state (i.e., prevState) and update it.
        setFile([file.name, e.target.result]);
      };
      // Read the file as Data URL (since we accept only images)
      reader.readAsBinaryString(file);
      return file;
    });
  }, []);

  return (
    <Dialog open={props.open} onClose={() => props.setOpen()}>
      <DialogTitle>Dokumentationsbogen einreichen</DialogTitle>
      <DialogContent sx={{ marginTop: 2 }}>
        <Dropzone
          onDrop={onDrop}
          file={file}
          accept={{ "application/pdf": [".pdf"] }}
        />

        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 3 }}>
          <ToggleButtonGroup
            color={alignment === "FAILED" ? "error" : "success"}
            value={alignment}
            exclusive
            onChange={handleChange}
            aria-label="Platform"
          >
            <ToggleButton value="FAILED">Durchgefallen</ToggleButton>
            <ToggleButton value="PASSED">Bestanden</ToggleButton>
          </ToggleButtonGroup>
        </Box>

        <Box sx={{ display: "flex", marginTop: 4 }}>
          <DialogContentText variant="caption">
            {file === null
              ? 'Bitte wählen Sie den für die "' +
                props.pharmacyName +
                '" ausgefüllten Dokumentationsbogen zum Hochladen aus.'
              : 'Sind Sie sicher, dass Sie die Angaben in "' +
                file[0] +
                '" für die "' +
                props.pharmacyName +
                '" einreichen wollen? Eine nachträgliche Änderung ist nicht mehr möglich! *'}
          </DialogContentText>
          {file === null ? null : (
            <Checkbox
              checked={checked}
              onChange={() => setChecked((prev) => !prev)}
              sx={{ alignSelf: "center" }}
            />
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => props.setOpen()}
          sx={{ color: theme.palette.mode === "dark" ? "#c4c4c4" : "#666666" }}
        >
          Abbrechen
        </Button>
        <Button
          onClick={handleClose}
          disabled={!checked || file === null || alignment === null}
        >
          Einreichen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
